import PubSub from "underpub-js";
import slick from "slick-carousel";

import {
  BREAKPOINTS
} from "../../../../../src/scripts/utils/variables";

var ListingInfo = function (options) {

  this.options = {
    $el: false,
    baseClass: 'mol-ListingInfo',
  };

  $.extend(true, this.options, options);

};

ListingInfo.prototype.init = function () {

  var self = this;

  self.$items = self.options.$el.find(`.${self.options.baseClass}__items`);
  self.$arrowPrev = self.options.$el.find(`.${self.options.baseClass}__arrow--prev`);
  self.$arrowNext = self.options.$el.find(`.${self.options.baseClass}__arrow--next`);

  self.$items.slick({
    prevArrow: self.$arrowPrev,
    nextArrow: self.$arrowNext,
    slidesToShow: 3,
    infinite: true,
    responsive: [
      {
        breakpoint: BREAKPOINTS.L,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: BREAKPOINTS.S,
        settings: {
          slidesToShow: 1,
        },
      },
    ]
  });

};

export default ListingInfo;
